import { createSelector } from 'reselect';
import { getActiveDetailedInformationTab, getActiveDetailedInformationTabV2 } from '../../selectors';
import { getTrendKPIsList } from './TrendKPIList/selectors';
import { getEnergyRelatedKPIsList } from './EnergyRelatedSignalsList/selectors';

export const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

export const getTrendKPIs = createSelector([
    ({ operationalParameters }) => operationalParameters?.availableKPIs?.trend?.data,
], (
    trendKPIs,
) => {
    return trendKPIs;
});

export const getSelectedTrendKPIs = ({ operationalParameters }) => {
    return operationalParameters?.preselectedKPIs?.single?.trend;
};

export const getMeasurementExportLoadingStatus = ({ downloadMeasurements }) => {
    return downloadMeasurements?.measurementExport?.loadingStatus;
};

export const getTrendKPIsLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.availableKPIs?.trend?.loadingStatus;
};

export const getTrendDataLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.charts?.single?.trend[0]?.loadingStatus;
};

export const getUserLimitsLoadingStatus = ({ detailedInformationHeader }) => {
    return detailedInformationHeader?.userLimits?.loadingStatus;
};

const getLimitFromSummary = ({ operationalParameters }) => {
    return operationalParameters?.limitFromSummary;
};

export const getModel = createSelector([
    getActiveDetailedInformationTab,
    getDateSelection,
    getMeasurementExportLoadingStatus,
    getSelectedTrendKPIs,
    getTrendKPIs,
    getTrendKPIsLoadingStatus,
    getTrendDataLoadingStatus,
    getUserLimitsLoadingStatus,
    getActiveDetailedInformationTabV2,
    getLimitFromSummary,
    getTrendKPIsList,
    getEnergyRelatedKPIsList
], (
    activeDetailedInformationTab,
    dateSelection,
    measurementExportLoadingStatus,
    selectedTrendKPIs,
    trendKPIs,
    trendKPIsLoadingStatus,
    trendDataLoadingStatus,
    userLimitsLoadingStatus,
    activeDetailedInformationTabV2,
    limitFromSummary,
    trendKPIsList,
    energyRelatedSignals
) => {
    return {
        activeDetailedInformationTab,
        dateSelection,
        measurementExportLoadingStatus,
        selectedTrendKPIs,
        trendKPIs,
        trendKPIsLoadingStatus,
        trendDataLoadingStatus,
        userLimitsLoadingStatus,
        activeDetailedInformationTabV2,
        limitFromSummary,
        trendKPIsList,
        energyRelatedSignals
    };
});
